import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import * as Sentry from "@sentry/browser";
import { userDataHandler } from "@redux/User/userDetailsSlice";
import { store } from "@redux/store";

export const shouldShowOnboarding = () => {
  const userData = store.getState().userDetails.userData;
  return userData?.show_onboarding_steps;
};

export const toShowOnboarding = async () => {
  //check 1
  const userCreatedData = store.getState().userDetails.userData.createdDate;
  const userData = {
    userCreatedData: userCreatedData,
    // userCreatedData: "2025-09-05T00:00:00.000Z", // do not remove this
    featureLaunchDate: "2025-09-01T00:00:00.000Z",
  };
  const userCreatedTime = new Date(userData.userCreatedData).getTime();
  const featureLaunchTime = new Date(userData.featureLaunchDate).getTime();

  const sixMonthsBeforeLaunch = new Date(userData.featureLaunchDate);
  sixMonthsBeforeLaunch.setMonth(sixMonthsBeforeLaunch.getMonth() - 6);
  const sixMonthsBeforeLaunchTime = sixMonthsBeforeLaunch.getTime();
  const shouldShowFeature = userCreatedTime > featureLaunchTime || (userCreatedTime >= sixMonthsBeforeLaunchTime && userCreatedTime <= featureLaunchTime);

  //check 2
  const data = await getData("onboarding_details");
  const hasAnyViewed = Object.values(data).some((item) => item.isViewed === true);

  const check = shouldShowFeature && !hasAnyViewed;
  updateOnboardingStatus("show_onboarding_steps", check);
  return check;
};

export const handlePatch = (onboardingType, key) => {
  axios
    .post(getApiUrl("user_profile_details/"), {
      profile_param_updated: onboardingType,
      updated_value: key,
    })
    .then(async () => {
      updateLocalStorageOnboardingStatus(onboardingType, key);
      updateOnboardingStatus("show_onboarding_steps", false);
    })
    .catch((err) => {
      Sentry.captureException(err);
    });
};
export const updateLocalStorageOnboardingStatus = (onboardingType, key) => {
  try {
    const existingData = JSON.parse(localStorage.getItem("onboarding")) || {};
    //for onboarding_details
    if (!existingData.onboarding_details && onboardingType === "onboarding") {
      existingData.onboarding_details = {};
    }
    if (existingData.onboarding_details[key] && onboardingType === "onboarding") {
      existingData.onboarding_details[key] = {
        ...existingData.onboarding_details[key],
        isViewed: true,
      };
    }
    //for strip_touchpoints
    if (!existingData.strip_touchpoints_details && onboardingType === "strip_touchpoints") {
      existingData.strip_touchpoints_details = {};
    }
    if (existingData.strip_touchpoints_details[key] && onboardingType === "strip_touchpoints") {
      existingData.strip_touchpoints_details[key] = {
        ...existingData.strip_touchpoints_details[key],
        isViewed: true,
      };
    }
    localStorage.setItem("onboarding", JSON.stringify(existingData));
    window.dispatchEvent(
      new StorageEvent("storage", {
        key: "onboarding",
        newValue: JSON.stringify(existingData),
      })
    );
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const getData = async (type) => {
  try {
    const stored = localStorage.getItem("onboarding");
    if (stored === null) return {};
    const parsed = JSON.parse(stored);
    return parsed[type] ?? {};
  } catch (error) {
    Sentry.captureException(error);
    return {};
  }
};

export const updateOnboardingStatus = (key, value) => {
  const currentUserData = store.getState().userDetails?.userData;
  store.dispatch(
    userDataHandler({
      ...currentUserData,
      [key]: value,
    })
  );
};

export const refreshOnboardingData = async () => {
  try {
    const response = await axios.get(getApiUrl("user_profile_details/"));
    const onboardingData = response.data.data;

    if (onboardingData && onboardingData.onboarding_details) {
      localStorage.setItem("onboarding", JSON.stringify(onboardingData));

      window.dispatchEvent(
        new StorageEvent("storage", {
          key: "onboarding",
          newValue: JSON.stringify(onboardingData),
        })
      );

      return onboardingData;
    }
  } catch (error) {
    Sentry.captureException(error);
  }
  return null;
};
